var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCouchIcon = function SvgCouchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5747",
    "data-name": "Grupo 5747",
    transform: "translate(-517 -775)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1994",
    "data-name": "Ret\\xE2ngulo 1994",
    width: 50,
    height: 50,
    transform: "translate(517 775)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2356",
    "data-name": "Caminho 2356",
    d: "M37.969,14.556l0-.008A5.667,5.667,0,0,0,33.676,10.4l-.116-.012A13.848,13.848,0,0,0,20.1,0H18.048A13.943,13.943,0,0,0,4.612,10.452,5.915,5.915,0,0,0,2,11.658a5.607,5.607,0,0,0,.093,8.66v9a4.654,4.654,0,0,0,2.092,3.853v1.273a3.6,3.6,0,0,0,7.209,0v-.513h15.4v.512a3.6,3.6,0,0,0,7.209,0V33.173a4.657,4.657,0,0,0,2.092-3.857V20.308A5.8,5.8,0,0,0,37.969,14.556ZM4.391,18.151a2.566,2.566,0,0,1-1.3-2.189,2.741,2.741,0,0,1,.912-2,2.534,2.534,0,0,1,1.713-.619,1.21,1.21,0,0,1,.349.059,2.732,2.732,0,0,1,2.167,2.75v9H29.884v-9.28a2.4,2.4,0,0,1,.969-1.968,2.433,2.433,0,0,1,2.13-.5,2.572,2.572,0,0,1,1.925,1.876,2.5,2.5,0,0,1-1.18,2.869l-.005,0a1.575,1.575,0,0,0-.79,1.378v9.863a1.484,1.484,0,0,1-.415,1.06,1.524,1.524,0,0,1-1.11.455H6.7a1.487,1.487,0,0,1-1.515-1.525V19.536A1.581,1.581,0,0,0,4.391,18.151Zm24.471-6.564a5.627,5.627,0,0,0-2.07,4.434v6.114H11.325v-5.91a5.972,5.972,0,0,0-3.6-5.5A10.933,10.933,0,0,1,18.046,3.092h2.048a10.673,10.673,0,0,1,10.235,7.617A5.359,5.359,0,0,0,28.862,11.587ZM8.233,34v.512a.513.513,0,1,1-1.025,0V34Zm22.675,0v.512a.513.513,0,1,1-1.025,0V34Z",
    transform: "translate(523 781)",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: 1.2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCouchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/couch-icon.04a08c30.svg";
export { ForwardRef as ReactComponent };